import {
  Routes,
  Route,
  BrowserRouter as ProviderRoute,
} from "react-router-dom";
import { Public } from "@Routes";

const Master = () => {
  return (
    <ProviderRoute>
      <Routes>
        <Route index path="/*" element={<Public />} />
      </Routes>
    </ProviderRoute>
  );
};

export default Master;